import React from "react";
import { Link } from "react-router-dom";
import Finger from "./image/finger.png";
import Gear from "./image/gear.png";

class MainBtn extends React.Component {
  render() {
    return (
      <div className="banner">
        <div className="main-container">
          <Link
            to={{
              pathname: "/QRread",
              state: { to: "/QRresult", text: "건강 체크" },
            }}
            className="main-button"
          >
            <button className="button">
              <p>건강 체크</p>
              <p>Health Check</p>
              <img src={Finger} alt="손가락" />
            </button>
          </Link>
          <Link
            to={{
              pathname: "/QRcreate",
            }}
            className="main-button1"
          >
            <button className="button">
              <p>QR 생성</p>
              <p>QR Create</p>
              <img src={Finger} alt="손가락" />
            </button>
          </Link>
          {/* <Link
            to={{
              pathname: "/QRread",
              state: { to: "/UserTrain", text:"체력 측정"},
            }}
            className="main-button2"
          >
            <button className="button">
              <p>등록 조회</p>
              <p>Registration inquiry</p>
              <img src={Finger} alt="손가락" />
            </button>
          </Link> */}
        </div>
        <div className="bottom">
          {/* <Link to="/QRcreate" className="main-button3">
            <button className="button">
              <p>QR 생성</p>
            </button>
          </Link> */}
          <Link to="/Setting" className="main-button4">
            <button className="button">
              <img src={Gear} alt="설정" />
            </button>
          </Link>
        </div>
      </div>
    );
  }
}

export default MainBtn;
